<p-toast />
<p-confirmDialog />

<div class="p-4 md:p-5 flex flex-col gap-4 max-w-screen-2xl mx-auto w-full" *ngIf="loading">
  <span class="text-surface-600 dark:text-surface-400">Carregando dados do TOI...</span>
</div>

<div class="p-4 md:p-5 flex flex-col gap-6 max-w-screen-2xl mx-auto w-full" *ngIf="!loading && detalhe">
  <p-message
    *ngIf="modoCorrecaoEndereco || exigeCorrecaoEndereco"
    severity="warn"
    styleClass="w-full">
    <ng-container *ngIf="mensagemErroEndereco; else semMensagemErro">
      <strong>Erro de endereço:</strong> {{ mensagemErroEndereco }}
    </ng-container>
    <ng-template #semMensagemErro>
      Este TOI aguarda correção de endereço para reencaminhamento aos Correios.
    </ng-template>
  </p-message>

  <div class="flex flex-wrap gap-2 items-center pb-1 border-b border-surface-200 dark:border-surface-700">
    <ng-container *ngIf="!editing; else acoesEdicao">
      <span
        *ngIf="permiteEdicaoUsuario && exigeCorrecaoEndereco && !modoCorrecaoEndereco"
        pTooltip="Corrigir endereço e reencaminhar para envio"
        tooltipPosition="bottom"
      >
        <p-button
          label="Corrigir endereço"
          icon="pi pi-map-marker"
          severity="warn"
          (onClick)="onCorrigirEndereco()"
          ariaLabel="Corrigir endereço do TOI"
        />
      </span>
      <span
        *ngIf="permiteEdicaoUsuario"
        [pTooltip]="edicaoBloqueada ? 'TOI entregue em mãos não permite edição.' : ''"
        tooltipPosition="bottom"
      >
      </span>
      <p-button
        label="Visualizar Formulário"
        icon="pi pi-file-pdf"
        severity="primary"
        (onClick)="onPdf()"
        ariaLabel="Exportar TOI em PDF"
      />
      <p-button
        label="Voltar"
        icon="pi pi-angle-left"
        severity="primary"
        variant="outlined"
        (onClick)="onVoltar()"
        ariaLabel="Voltar para a aba anterior"
      />
    </ng-container>
    <ng-template #acoesEdicao>
      <p-button
        [label]="modoCorrecaoEndereco ? 'Confirmar correção' : 'Salvar'"
        icon="pi pi-save"
        [loading]="saving"
        (onClick)="onSalvar()"
        [ariaLabel]="modoCorrecaoEndereco ? 'Confirmar correção de endereço' : 'Salvar alterações do TOI'"
      />
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        severity="secondary"
        [disabled]="saving"
        (onClick)="onCancelar()"
        ariaLabel="Cancelar edição do TOI"
      />
    </ng-template>
  </div>

  <div
    class="text-center font-semibold text-lg px-4 py-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900 text-surface-900 dark:text-surface-0"
  >
    {{ detalhe.tituloTermo }}
  </div>


  <div class="flex items-center gap-2 px-1 justify-center">
    <label class="font-semibold min-w-fit">Status TOI:</label>
    <span
      class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-base font-medium bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 border border-primary-200 dark:border-primary-700"
    >
      <i class="pi pi-info-circle text-xs" aria-hidden="true"></i>
      {{ statusToiAtual }}
    </span>
  </div>

  <form
    [formGroup]="editForm!"
    *ngIf="editing && editForm; else conteudoSomenteLeitura"
    class="flex flex-col gap-6"
  >
    <ng-container *ngTemplateOutlet="conteudoPrincipal"></ng-container>
  </form>

  <ng-template #conteudoSomenteLeitura>
    <div class="flex flex-col gap-6">
      <ng-container *ngTemplateOutlet="conteudoPrincipal"></ng-container>
    </div>
  </ng-template>

  <ng-template #conteudoPrincipal>
    <ng-container *ngTemplateOutlet="dadosOsTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="irregularidadesTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="imagensTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="atencaoTemplate"></ng-container>
  </ng-template>

  <ng-template #dadosOsTemplate>
    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Dados da OS</span>
      </ng-template>
      <div class="flex justify-center md:justify-start px-4 pt-4 pb-2 border-b border-surface-200 dark:border-surface-700">
        <img
          src="assets/layout/images/copasa.png"
          alt="Copasa"
          class="max-h-12 w-auto max-w-[200px] object-contain object-left"
          width="160"
          height="48"
          loading="lazy"
        />
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
        <div class="flex flex-col gap-3 md:pl-2">
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Número da OS:</label>
            <div class="ml-3">{{ detalhe.numeroOS }}</div>
          </div>
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Número do Documento:</label>
            <div class="ml-3">{{ detalhe.numeroDocumento }}</div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">Gerência Regional:</label>
            <div class="ml-3">{{ detalhe.gerenciaRegional }}</div>
          </div>
          <div class="flex flex-col gap-2">
            <label class="font-semibold min-w-fit">Número de Unidades por Categoria:</label>
            <p-table
              [value]="detalhe.economiaPorCategorias"
              styleClass="p-datatable-sm"
              [tableStyle]="{ 'min-width': '100%' }"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>TPS</th>
                  <th>Comercial</th>
                  <th>Industrial</th>
                  <th>Pública</th>
                  <th>Residencial</th>
                  <th>Social</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.tipoLinha }}</td>
                  <td>{{ row.comercial }}</td>
                  <td>{{ row.industrial }}</td>
                  <td>{{ row.publica }}</td>
                  <td>{{ row.residencial }}</td>
                  <td>{{ row.social }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">
              Endereço da unidade usuária:<span *ngIf="editing" class="text-red-500"> *</span>
            </label>
            <ng-container *ngIf="editing && editForm; else enderecoSomenteLeitura">
              <div class="flex flex-col flex-1 ml-0 md:ml-3" [formGroup]="editForm">
                <input
                  pInputText
                  type="text"
                  [formControl]="enderecoUnidadeUsuariaControl"
                  class="w-full p-inputtext p-component"
                />
                <small
                  class="text-red-500 mt-1"
                  *ngIf="
                    enderecoUnidadeUsuariaControl.invalid && enderecoUnidadeUsuariaControl.touched
                  "
                  >Obrigatório</small
                >
              </div>
            </ng-container>
            <ng-template #enderecoSomenteLeitura>
              <div class="ml-3">{{ detalhe.enderecoUnidadeUsuaria }}</div>
            </ng-template>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">Usuário Cadastrado:</label>
            <div class="ml-3">{{ detalhe.usuarioCadastrado }}</div>
          </div>
        </div>

        <div class="flex flex-col gap-3 md:border-l md:border-surface-200 dark:md:border-surface-700 md:ps-6">
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">Data de Conclusão da OS:</label>
            <div class="ml-3">{{ detalhe.dataConclusao | date : 'dd/MM/yyyy' }}</div>
          </div>
          <div class="flex gap-2">
            <label class="font-semibold min-w-fit">Modelo:</label>
            <div class="ml-3">{{ detalhe.cdModeloToi }}</div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">Localidade:</label>
            <div class="ml-3">{{ detalhe.localidade }}</div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">Matrícula do Imóvel:</label>
            <div class="ml-3">{{ detalhe.matriculaImovel }}</div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-2">
            <label class="font-semibold min-w-fit">Identificador do Usuário:</label>
            <div class="ml-3">{{ detalhe.identificadorUsuario }}</div>
          </div>
        </div>
      </div>
    </p-fieldset>
  </ng-template>

  <ng-template #irregularidadesTemplate>
    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Irregularidade / infração detectada</span>
      </ng-template>
      <div class="p-4 flex flex-col gap-3">
        <p *ngIf="detalhe.dsTipoInfracao" class="m-0 font-medium text-surface-900 dark:text-surface-0">
          {{ detalhe.dsTipoInfracao }}
        </p>
        <p *ngIf="detalhe.dsTipoIrregularidade" class="m-0 text-surface-800 dark:text-surface-200">
          <span class="font-semibold">Irregularidade:</span>
          {{ detalhe.dsTipoIrregularidade }}
        </p>
        <ol
          *ngIf="detalhe.irregularidades.length"
          class="m-0 pl-5 list-decimal text-surface-800 dark:text-surface-200 space-y-2"
        >
          <li *ngFor="let item of detalhe.irregularidades">
            <span class="font-medium">{{ item.dsTipoInfracao }}</span>
            <span *ngIf="item.resposta" class="ml-2">{{ item.resposta }}</span>
          </li>
        </ol>
      </div>
    </p-fieldset>
  </ng-template>

  <ng-template #imagensTemplate>
    <p-fieldset toggleable="true">
      <ng-template pTemplate="header">
        <span class="font-semibold">Imagens</span>
      </ng-template>
      <div class="relative p-4 pt-5">
        <span
          *ngIf="detalhe.versaoExibicao"
          class="absolute top-3 right-3 z-1 text-xs font-medium bg-surface-200 text-surface-800 dark:bg-surface-700 dark:text-surface-100 rounded-full w-10 h-10 inline-flex items-center justify-center shadow-sm"
          >{{ detalhe.versaoExibicao }}</span
        >
        <div class="flex flex-wrap gap-4 md:gap-5 pe-12">
          <div
            *ngFor="let m of detalhe.midias; let i = index"
            class="flex flex-col items-start gap-2 w-44 sm:w-48 shrink-0"
            [class.opacity-50]="isMidiaOculta(m, i)"
          >
            <div
              class="toi-midia-thumb w-full rounded-lg border border-surface-200 dark:border-surface-700 flex items-center justify-center overflow-hidden aspect-[4/3] min-h-24 bg-surface-100 dark:bg-surface-800 relative"
            >
              <p-image
                *ngIf="m.urlThumbnail"
                [src]="m.urlThumbnail"
                [previewImageSrc]="midiaUrlAmpliada(m)"
                [alt]="m.legenda"
                [preview]="true"
                appendTo="body"
                loading="lazy"
                styleClass="toi-midia-preview"
                imageClass="w-full h-full max-w-full max-h-full object-contain object-center"
                pTooltip="Clique para ampliar"
                tooltipPosition="top"
              />
              <i *ngIf="!m.urlThumbnail" class="pi pi-image text-4xl text-surface-400" aria-hidden="true"></i>
              <span
                *ngIf="isMidiaOculta(m, i)"
                class="absolute top-1 left-1 text-[10px] font-semibold bg-surface-900/80 text-surface-0 px-2 py-0.5 rounded pointer-events-none"
                >Oculto no PDF</span
              >
            </div>
            <a
              *ngIf="m.downloadUrl"
              [href]="m.downloadUrl"
              class="flex items-center gap-1.5 text-primary no-underline hover:underline"
              [attr.aria-label]="'Download ' + m.legenda"
            >
              <i class="pi pi-download shrink-0" aria-hidden="true"></i>
              <span class="text-sm text-surface-700 dark:text-surface-300 leading-snug">{{ m.legenda }}</span>
            </a>
            <span *ngIf="!m.downloadUrl" class="text-sm text-surface-700 dark:text-surface-300 leading-snug">{{
              m.legenda
            }}</span>
            <div class="flex items-center gap-2">
              <p-toggleswitch
                [ngModel]="isMidiaIncluirNoPdf(m, i)"
                (ngModelChange)="setMidiaIncluirNoPdf(m, $event, i)"
                [inputId]="'toi-midia-pdf-' + i"
                [ariaLabel]="'Incluir ' + m.legenda + ' no PDF'"
              />
              <label [for]="'toi-midia-pdf-' + i" class="text-sm text-surface-700 dark:text-surface-300 cursor-pointer">
                Incluir no PDF
              </label>
            </div>
          </div>
        </div>
      </div>
    </p-fieldset>
  </ng-template>

  <ng-template #atencaoTemplate>
    <p-fieldset>
      <ng-template pTemplate="header">
        <span class="font-semibold">Atenção</span>
      </ng-template>
      <div class="p-4 flex flex-col gap-3">
        <ol class="m-0 pl-5 list-decimal text-surface-800 dark:text-surface-200 space-y-2 leading-relaxed">
          <li *ngFor="let p of detalhe.atencaoParagrafos">{{ p }}</li>
        </ol>
      </div>
    </p-fieldset>
  </ng-template>

  <p-fieldset>
    <ng-template pTemplate="header">
      <span class="font-semibold">Controle de alteração</span>
    </ng-template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
      <div class="flex flex-col gap-3 md:pl-2">
        <div class="flex gap-2">
          <label class="font-semibold min-w-fit">Última Alteração:</label>
          <div class="ml-3">{{ detalhe.ultimaAlteracao | date : 'dd/MM/yyyy HH:mm:ss' }}</div>
        </div>
        <div class="flex gap-2">
          <label class="font-semibold min-w-fit">Usuário da Alteração:</label>
          <div class="ml-3">{{ detalhe.usuarioAlteracao }}</div>
        </div>
        <div class="flex gap-2">
          <label class="font-semibold min-w-fit">TOI entregue para o usuário:</label>
          <div class="ml-3">{{ detalhe.toiEntregueUsuario }}</div>
        </div>
      </div>
    </div>
  </p-fieldset>

  <p-fieldset>
    <ng-template pTemplate="header">
      <span class="font-semibold">Histórico de Eventos</span>
    </ng-template>
    <p-table
      styleClass="p-datatable-sm p-datatable-gridlines"
      [value]="detalhe.eventosToi"
      [scrollable]="true"
      scrollHeight="300px"
      [sortField]="'dataInicio'"
      [sortOrder]="-1"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="usuarioAlteracao">
            Usuário da Alteração
            <p-sortIcon field="usuarioAlteracao" />
          </th>
          <th pSortableColumn="dataInicio">
            Data Início
            <p-sortIcon field="dataInicio" />
          </th>
          <th pSortableColumn="dataFim">
            Data Fim
            <p-sortIcon field="dataFim" />
          </th>
          <th>Status</th>
          <th>Observações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-event>
        <tr>
          <td>{{ event.usuarioAlteracao }}</td>
          <td>{{ event.dataInicio | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ event.dataFim ? (event.dataFim | date : 'dd/MM/yyyy HH:mm:ss') : '-' }}</td>
          <td>{{ event.status }}</td>
          <td>{{ event.observacao }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center text-surface-500 dark:text-surface-400 py-4">
            Nenhum evento registrado.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-fieldset>

  <p-fieldset *ngIf="checklistItensOrdenados.length">
    <ng-template pTemplate="header">
      <span class="font-semibold">Checklist TOI</span>
    </ng-template>
    <div class="p-4 flex flex-col gap-4">
      <div
        *ngFor="let item of checklistItensOrdenados"
        class="toi-checklist-item flex flex-col gap-2 pb-4 mb-1 border-b border-surface-200 dark:border-surface-700 last:border-0 last:pb-0 last:mb-0"
      >
        <label
          *ngIf="item.label"
          class="w-full font-semibold block text-surface-900 dark:text-surface-0"
          [innerHTML]="item.label | safeHtml"
        ></label>

        <div class="flex flex-wrap gap-3 items-center">
          <input
            *ngIf="tipoChecklistItem(item) === 'checkbox'"
            type="checkbox"
            class="w-5 h-5"
            [checked]="isChecklistMarcado(item)"
            disabled
            [attr.aria-label]="item.label"
          />

          <ng-container *ngIf="tipoChecklistItem(item) === 'imagem' && checklistImagemSrc(item) as imagemSrc">
            <div class="flex flex-col gap-2">
              <img
                [src]="imagemSrc"
                [alt]="item.label || 'Imagem do checklist'"
                class="toi-checklist-imagem cursor-pointer border-4 border-surface-200 dark:border-surface-700 max-h-24 w-auto object-contain"
                loading="lazy"
              />
              <a
                [href]="imagemSrc"
                target="_blank"
                rel="noopener noreferrer"
                class="flex items-center gap-1.5 text-primary no-underline hover:underline text-sm"
              >
                <i class="pi pi-download shrink-0" aria-hidden="true"></i>
                <span>{{ item.valor || 'Download' }}</span>
              </a>
            </div>
          </ng-container>

          <span
            *ngIf="tipoChecklistItem(item) === 'texto'"
            class="text-surface-800 dark:text-surface-200 whitespace-pre-wrap break-words"
          >
            {{ checklistValorTexto(item) }}
          </span>
        </div>
      </div>
    </div>
  </p-fieldset>
</div>

<div class="p-4 md:p-5 max-w-screen-2xl mx-auto" *ngIf="!loading && !detalhe">
  <span class="text-surface-600 dark:text-surface-400">Não há dados do TOI para exibir.</span>
</div>
